import { NgModule } from '@angular/core';

import {SharedModule} from "../../shared/shared.module";
import {TipoViagemApiService} from "./shared/tipo-viagem-api.service";

@NgModule({
    imports: [
        SharedModule,
    ],
    providers: [
        TipoViagemApiService
    ],
    declarations: [
        
    ]
})
export class TiposViagemModule { }



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/viagens/tipos-viagem/tipos-viagem.module.ts
 **/